"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdSection = void 0;
const react_1 = __importStar(require("react"));
const ThirdSection_elements_1 = require("./ThirdSection.elements");
const girl_webp_1 = __importDefault(require("@images/landing/main/thirdSection/girl.webp"));
const parents_webp_1 = __importDefault(require("@images/landing/main/thirdSection/parents.webp"));
const therapist_webp_1 = __importDefault(require("@images/landing/main/thirdSection/therapist.webp"));
const Landing_1 = require("@app/routes/Landing");
const ThirdSection_translations_1 = require("./ThirdSection.translations");
const ThirdSection = ({}) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = ThirdSection_translations_1.translations[language];
    return (react_1.default.createElement(ThirdSection_elements_1.ThirdSectionWrap, null,
        react_1.default.createElement("h1", null, t.h1),
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", { className: "landing-third-section-children" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", null, t.content["1"].h3),
                    react_1.default.createElement("p", null, t.content["1"].p)),
                react_1.default.createElement("img", { src: girl_webp_1.default, width: 305, height: 469, alt: "" })),
            react_1.default.createElement("li", { className: "landing-third-section-parents" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", null, t.content["2"].h3),
                    react_1.default.createElement("p", null, t.content["2"].p)),
                react_1.default.createElement("img", { src: parents_webp_1.default, width: 443, height: 773, alt: "" })),
            react_1.default.createElement("li", { className: "landing-third-section-therapists" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", null, t.content["3"].h3),
                    react_1.default.createElement("p", null, t.content["3"].p)),
                react_1.default.createElement("img", { src: therapist_webp_1.default, width: 322, height: 794, alt: "" })))));
};
exports.ThirdSection = ThirdSection;
